// ============ ZEN ERP — Çok Dilli Metin Katmanı (Aşama 1) ============
// Sözlük anahtarı DOĞRUDAN Türkçe metnin kendisidir. Böylece 10.000 satırlık
// arayüzü kademeli olarak sarmalayabiliyoruz: çevirisi olmayan bir metin
// otomatik olarak Türkçe kalır (hiçbir zaman boş/kırık ekran oluşmaz).
import { STATUS_LABELS } from "./mock";

export const EN = {
  // — Üst bar / genel kimlik —
  "Perde Sistemleri": "Curtain Systems",
  "ERP Yönetim Paneli": "ERP Management Panel",

  // — Sol menü —
  "Ana Sayfa": "Home",
  "Sipariş Girişi": "Order Entry",
  "Verilen Teklifler": "Quotes Issued",
  "Fatura & İrsaliye": "Invoices & Dispatch",
  "Çeki Listesi": "Packing List",
  "Cari Takip": "Accounts",
  "Muhasebe / Ödemeler": "Accounting / Payments",
  "Stok Yönetimi": "Stock Management",
  "Fiyat Listeleri": "Price Lists",
  "Raporlar": "Reports",
  "CRM": "CRM",
  "CRM — Aday Müşteri Takibi": "CRM — Lead Tracking",
  "Satış Hattı": "Pipeline",
  "Takip Listesi": "Follow-ups",
  "Yeni Aday": "New Lead",
  "Yeni Aday Müşteri": "New Lead",
  "Adayı Düzenle": "Edit Lead",
  "Talep Başlığı": "Request Title",
  "Mevcut Cari": "Existing Account",
  "— Yeni / cariye bağlı değil —": "— New / not linked to an account —",
  "Müşteri Adı": "Customer Name",
  "İlgili Kişi": "Contact Person",
  "Telefon": "Phone",
  "E-posta": "Email",
  "Kaynak": "Source",
  "Aşama": "Stage",
  "Tahmini Tutar": "Estimated Value",
  "Para Birimi": "Currency",
  "Bağlı Teklif": "Linked Quote",
  "— Yok —": "— None —",
  "Sonraki Takip": "Next Follow-up",
  "Sorumlu": "Owner",
  "Tek Tıkla Siparişe Dönüştür": "Convert to Order",
  "Siparişe dönüştürüldü": "Converted to order",
  "Görüşme Notu Ekle": "Add Meeting Note",
  "Görüşmede konuşulanlar...": "What was discussed...",
  "Not Ekle": "Add Note",
  "Not eklendi": "Note added",
  "Not metni boş": "Note text is empty",
  "Görüşme Geçmişi": "Interaction History",
  "Henüz not yok": "No notes yet",
  "Müşteri Geçmişi": "Customer History",
  "Teklifler": "Quotes",
  "Akıllı Sesli Not": "Smart Voice Note",
  "Kaydı bitirdiğinizde konuşma otomatik yazıya çevrilir ve önemli detaylar özetlenir.": "When you stop recording, the speech is transcribed automatically and the key details are summarised.",
  "Sesli Not Al": "Record Voice Note",
  "Kaydı Bitir": "Stop Recording",
  "Yazıya çevriliyor...": "Transcribing...",
  "Sesli not yazıya çevrildi ve kaydedildi": "Voice note transcribed and saved",
  "Sesli not kaydedilemedi": "Could not save the voice note",
  "Mikrofona erişilemedi": "Could not access the microphone",
  "Sesli Not": "Voice Note",
  "AI Özeti": "AI Summary",
  "Önerilen Teklif Kalemi": "Suggested Quote Item",
  "Teklif Kalemine Dönüştür": "Convert to Quote Item",
  "Teklif kalemi oluşturuldu": "Quote item created",
  "Teklif kalemi oluşturulamadı": "Could not create the quote item",
  "Teklife eklendi": "Added to quote",
  "WhatsApp Gönder": "Send WhatsApp",
  "WhatsApp açıldı ve nota işlendi": "WhatsApp opened and logged as a note",
  "WhatsApp mesajı gönderildi": "WhatsApp message sent",
  "Bu kayıtta telefon numarası yok": "This lead has no phone number",
  "CRM Takipleri": "CRM Follow-ups",
  "Bugün aranacaklar ve gecikmiş takipler": "To call today and overdue follow-ups",
  "Bekleyen takip yok": "No pending follow-ups",
  "Tümünü Gör": "View All",
  "Aşama güncellendi": "Stage updated",
  "Bu aday kaydı silinsin mi?": "Delete this lead?",
  "Müşteri adı veya talep başlığı gerekli": "Customer name or request title is required",
  "Gecikmiş": "Overdue",
  "Yaklaşan": "Upcoming",
  "Kayıt yok": "No records",
  "Aday / Talep": "Lead / Request",
  "Müşteri": "Customer",
  "Tarih": "Date",
  "Kaydedildi": "Saved",
  "Silindi": "Deleted",
  "Sipariş": "Order",
  "Ayarlar": "Settings",

  // — Ana sayfa —
  "Hoş geldin": "Welcome",
  "TCMB Günlük Kur": "CBRT Daily Rate",
  "Teklif Hazırla": "Create Quote",
  "Toplam Sipariş": "Total Orders",
  "Cari Sayısı": "Accounts",
  "Yeni Sipariş": "New Order",
  "Sipariş Düzenle": "Edit Order",
  "Siparişler": "Orders",
  "Ürünler": "Products",
  "Faturalar": "Invoices",
  "İrsaliyeler": "Dispatch Notes",
  "Genel Sipariş Raporu": "Overall Order Report",
  "Duyuru ekle": "Add announcement",
  "Duyurular": "Announcements",
  "Duyuru metnini yazın...": "Write the announcement...",
  "Resim Ekle": "Add Image",
  "Kaydediliyor...": "Saving...",
  "Yayınla": "Publish",
  "Vazgeç": "Cancel",
  "Henüz duyuru yok. Zil ikonuna tıklayarak duyuru ekleyebilirsiniz.": "No announcements yet. Click the bell icon to add one.",
  "Şu an için herhangi bir duyuru bulunmamaktadır.": "There are no announcements at the moment.",
  "Duyuruyu sil": "Delete announcement",
  "Satışlar": "Sales",
  "Alışlar": "Purchases",
  "İadeler": "Returns",
  "Bugün": "Today",
  "Bu Ay": "This Month",
  "İşlem Bekleyen Siparişler": "Orders Awaiting Action",
  "İmalatta": "In Production",
  "Kargolanacak": "Ready to Ship",
  "Kargoya Hazır": "Ready to Ship",
  "Yollandı": "Shipped",
  "Ödeme Bekliyor": "Awaiting Payment",
  "Ödeme İste": "Request Payment",
  "Kısmi Ödeme": "Partial Payment",
  "Ödendi": "Paid",
  "Kalan": "Balance",
  "Sipariş Geçmişi": "Order History",
  "kayıt": "records",
  "Müşteri / proje ara…": "Search customer / project…",
  "Tümü": "All",
  "Teklif": "Quote",
  "Onay Bekliyor": "Pending Approval",
  "Onayla": "Approve",
  "Sipariş No": "Order No",
  "Müşteri / Proje": "Customer / Project",
  "Durum": "Status",
  "Oluşturma": "Created",
  "Onay Tarihi": "Approval Date",
  "Termin": "Due Date",
  "Tutar": "Amount",
  "Filtrelerle eşleşen sipariş yok": "No orders match the filters",
  "Termin süresi geçti": "Past due date",
  "1 haftayı geçti, termin girilmemiş": "Over a week old, no due date entered",
  "Sipariş ara... (no, müşteri)": "Search orders... (no, customer)",
  "Termin Takvimi": "Due Date Calendar",
  "Önümüzdeki 7 günde termin yok": "No due dates in the next 7 days",
  "Bugün!": "Today!",
  "Durum Özeti": "Status Summary",
  "Onay / İmalatta": "Approved / In Production",
  "Yükleniyor...": "Loading...",
  "Toplam Aktif": "Total Active",
  "Son Siparişler": "Recent Orders",
  "Henüz sipariş yok": "No orders yet",
  "Genel & Firma": "General & Company",
  "Kartela Yönetimi": "Colour Chart Management",
  "Ödeme Ayarları": "Payment Settings",
  "Açılış Haritası": "Open-Event Map",
  "WhatsApp Teklif Metni": "WhatsApp Quote Message",
  "Teklif WhatsApp ile paylaşılırken kullanılacak IBAN, geçerlilik ve imza bilgileri. Şablonda kullanılabilir değişkenler:": "IBAN, validity and signature details used when a quote is shared over WhatsApp. Variables available in the template:",
  "Varsayılana Dön": "Reset to Default",
  "Kaydedilemedi": "Could not be saved",
  "Yazıcılar": "Printers",
  "Satış Durumları": "Sales Statuses",
  "Kur Override": "Rate Override",
  "Depo Konumları": "Warehouse Locations",
  "Kullanıcılar & Roller": "Users & Roles",
  "E-posta Şablonları": "Email Templates",
  "Ödeme Yöntemleri": "Payment Methods",
  "Kargo Firmaları": "Shipping Companies",
  "Ölçü Birimleri": "Units of Measure",
  "Yedekleme": "Backup",
  "API Anahtarları": "API Keys",
  "Dil & Bölge": "Language & Region",
  "Paneli kapat": "Collapse panel",
  "Paneli aç": "Expand panel",

  // — Sipariş listesi —
  "Ara...": "Search...",
  "Yeni Kayıt Ekle": "Add New Record",
  "Teklif (Onaylanmamış)": "Quote (Not Approved)",
  "İptal": "Cancel",
  "Sıra": "No.",
  "Sipariş Durumu": "Order Status",
  "Cari": "Account",
  "Proje - Referans": "Project - Reference",
  "Sipariş Formları": "Order Forms",
  "Parça": "Items",
  "İşlem": "Action",
  "Durumu Değiştir": "Change Status",
  "Hazır": "Ready",
  "Düzenle": "Edit",
  "Sil": "Delete",
  "Yazdır": "Print",
  "Kaydet": "Save",
  "Ürün Grubu": "Product Group",
  "Mod": "Mode",
  "m² Fiyat": "Price / m²",
  "Para": "Currency",
  "KDV": "VAT",
  "Eşleşen ürün yok.": "No matching product.",
  "Ürün Seçiniz": "Select Product",
  "Seçiniz": "Select",
  "Seçiniz (opsiyonel)": "Select (optional)",
  "Seçiniz (AJ kodu)": "Select (AJ code)",
  "Sonuç yok": "No results",
  "En (cm)": "Width (cm)",
  "Boy (cm)": "Height (cm)",
  "Genişlik": "Width",
  "Adet": "Qty",
  "adet": "pcs",
  "Kumaş": "Fabric",
  "Kumaş / renk": "Fabric / colour",
  "Kumaş Çeşidi": "Fabric Type",
  "— Kumaş Çeşidi Seçiniz —": "— Select Fabric Type —",
  "Kumaş ara (isim veya kod)…": "Search fabric (name or code)…",
  "RAL / Renk": "RAL / Colour",
  "RAL Kodu": "RAL Code",
  "RAL kodu veya renk ara…": "Search RAL code or colour…",
  "Renk Tipi": "Colour Type",
  "Renk sayısı:": "Colour count:",
  "Kasa": "Cassette",
  "Kasa Rengi": "Cassette Colour",
  "Kasa Tipi": "Cassette Type",
  "Kasa Tipi Seçiniz": "Select Cassette Type",
  "Kasa Ölçüsü": "Cassette Size",
  "Kasa / Lamel Rengi": "Cassette / Slat Colour",
  "Renkli Kasa": "Coloured Cassette",
  "Mekanizma": "Mechanism",
  "Regülatörlü Mekanizma": "Regulated Mechanism",
  "Motor": "Motor",
  "Motor Tipi": "Motor Type",
  "Motor seçiniz": "Select motor",
  "— Motor Seçiniz —": "— Select Motor —",
  "Motor Kumandası": "Motor Remote",
  "Uzaktan Kumanda": "Remote Control",
  "Kumanda seçiniz": "Select remote",
  "Kumanda Yok": "No Remote",
  "Kumanda Fiyatı:": "Remote Price:",
  "Tek Kanal": "Single Channel",
  "5 Kanal": "5 Channel",
  "16 Kanal": "16 Channel",
  "Zincir": "Chain",
  "Metal Zincir": "Metal Chain",
  "Plastik Zincir": "Plastic Chain",
  "Yön": "Direction",
  "Yön (Kablo/Kumanda)": "Direction (Cable/Control)",
  "Kablo Çıkış Yönü": "Cable Exit Direction",
  "Sağ": "Right",
  "Sol": "Left",
  "SAĞ — R": "RIGHT — R",
  "SOL — L": "LEFT — L",
  "Montaj Ayağı": "Mounting Bracket",
  "Alt Çıta": "Bottom Rail",
  "Altlık": "Base",
  "Altlık Üstü Çıta": "Rail Above Base",
  "Etek Kesimi": "Skirt Cut",
  "Yan Kanal": "Side Channel",
  "Sistem": "System",
  "Sistem Tipi": "System Type",
  "Slat Genişliği": "Slat Width",
  "Slat Rengi": "Slat Colour",
  "Slayt Tipi": "Slat Type",
  "Ray Tipi": "Track Type",
  "Ray Tipi Seçiniz": "Select Track Type",
  "Ray Genişliği": "Track Width",
  "Zip Modeli": "Zip Model",
  "ZIP Çeşidi": "ZIP Type",
  "Zıgıl Sistem": "Weight Bar System",
  "Zıgıl Aparatı": "Weight Bar Fitting",
  "Stor Zigıl Sistemi": "Roller Weight Bar System",
  "Çocuk Zigıl Sistemi": "Child-safe Weight Bar",
  "Efor Çekim Sistemi": "Assisted Pull System",
  "Gece-Gündüz": "Day & Night",
  "Çift Cam Arası": "Between Double Glazing",
  "Aksesuar Törlüçüm": "Accessory Trim",
  "Renk Törlüçüm (İp)": "Colour Trim (Cord)",
  "Kumaş Kasa / Mekanizma Kaplama": "Fabric Cassette / Mechanism Cover",
  "Ahşap Rengi": "Wood Colour",
  "Ahşap Çeşidi": "Wood Type",
  "Boya Türü": "Paint Type",
  "Akrilik": "Acrylic",
  "Dikey Tipi": "Vertical Type",
  "Hesaplanan Slayt Sayısı": "Calculated Slat Count",
  "Ekstralar": "Extras",
  "Oda / Etiket": "Room / Label",
  "Örn: Salon": "e.g. Living Room",
  "Not": "Note",
  "Not:": "Note:",
  "Fiyat": "Price",
  "Fiyat kaynağı": "Price source",
  "Maliyet:": "Cost:",
  "Alış:": "Purchase:",
  "Sepete Ekle": "Add to Cart",
  "Kalemi Güncelle": "Update Item",
  "← Ürün Listesine Geri Dön": "← Back to Product List",
  "✕ Seçimi temizle": "✕ Clear selection",
  "Ürün / Slat": "Product / Slat",
  "MOTORLU": "MOTORISED",
  "DÜŞÜK STOK": "LOW STOCK",
  "STOK DIŞI": "OUT OF STOCK",
  "STOK DIŞI KUMAŞ": "OUT-OF-STOCK FABRIC",
  "YETERSİZ KUMAŞ STOĞU": "INSUFFICIENT FABRIC STOCK",
  "ÖLÇÜ SINIR DIŞI": "SIZE OUT OF RANGE",
  "ZARARINA SATIŞ!": "SELLING AT A LOSS!",
  "(min ölçü uygulandı)": "(minimum size applied)",
  "(ayrı kalem)": "(separate item)",
  "Stok dışı olduğunu biliyorum, yine de devam et": "I know it is out of stock, continue anyway",
  "Önce dikey perde tipini seçiniz": "Select the vertical blind type first",
  "Önce kumaş markasını seçiniz": "Select the fabric brand first",
  "Transparan kumaş tek çeşittir — varyant/kod seçimi yoktur.": "Transparent fabric has a single variant — no code selection.",
  "Transparan Kumaş": "Transparent Fabric",
  "Yaylı Sistem (Motorsuz)": "Spring System (No Motor)",
  "Var (Butonlu Sistem)": "Yes (Button System)",
  "Sipariş Föyü": "Order Sheet",
  "Sepet": "Cart",
  "Ara Toplam": "Subtotal",
  "Genel Toplam": "Grand Total",
  "İskonto": "Discount",
  "Müşteri": "Customer",
  "Proje": "Project",
  "Kapat": "Close",
  "Önizleme": "Preview",
  "Önizleme hazırlanıyor…": "Preparing preview…",
  "Yazdır / Gönder": "Print / Send",
  "Belge": "Document",
  "Yeni Cari Hesap": "New Account",
  "Cari Düzenle": "Edit Account",
  "Türkiye'de satış yaptığımız firma/kişi": "Company/person we sell to inside Türkiye",
  "Yurt dışı satış yaptığımız firma/kişi": "Company/person we sell to abroad",
  "Alım yaptığımız firma": "Company we purchase from",
  "Personel avans/cari takibi": "Staff advance / account tracking",
  "Yeni":"New",
  "Tüm markalar":"All brands",
  "Stok Takibi AÇIK": "Stock Tracking ON",
  "eşik": "threshold",
  "Stok Takibi KAPALI — Ayarlar > Genel'den açabilirsiniz": "Stock Tracking OFF — you can enable it in Settings > General",
  "Yurt İçi Müşteri": "Domestic Customer",
  "Yurt Dışı Müşteri": "Export Customer",
  "Çalışanlar": "Employees",
  "Çalışan": "Employee",
  "Perakende Müşteri": "Retail Customer",
  "Toplam Bakiye (EUR)": "Total Balance (EUR)",
  "Toplam Bakiye (TL)": "Total Balance (TL)",
  "Kartelalar (Kumaş/RAL/Motor)": "Colour Charts (Fabric/RAL/Motor)",
  "Ağırlık Tanımları": "Weight Definitions",
  "Ürün Grupları": "Product Groups",
  "Zip/Sineklik Matrisi": "Zip/Insect Screen Matrix",
  "İçeri Aktar": "Import",
  "Alış Fiyat Listeleri": "Purchase Price Lists",
  "Alış-Satış Marj Raporu": "Purchase–Sales Margin Report",
  "Her ürün için minimum/maksimum en-boy limitleri ve fiyat kuralı. AI ile değiştirebilirsiniz.": "Minimum/maximum width-height limits and the price rule for each product. You can change them with AI.",
  "Yeni Kumaş": "New Fabric",
  "Stok Dışı": "Out of Stock",
  "Tüm markalar": "All brands",
  "MARKA": "BRAND",
  "Marka": "Brand",
  "ZIP RAL Paleti": "ZIP RAL Palette",
  "Ahşap (AJ)": "Wood (AJ)",
  "Metal Slat": "Metal Slat",
  "Mekanizma / Oluk": "Mechanism / Channel",
  "Kumanda": "Remote",
  "Toplu İçeri Aktarım": "Bulk Import",

  "Cari Hesaplar / Müşteriler": "Accounts / Customers",
  "Ekstre, WhatsApp paylaşım ve döviz bazlı bakiye takibi.": "Statements, WhatsApp sharing and multi-currency balance tracking.",
  "Yeni Cari": "New Account",
  "Cari Tipi": "Account Type",
  "Cari Grubu": "Account Group",
  "Cari İndirim (%)": "Account Discount (%)",
  "Cari Bakiye Durumu": "Account Balance Status",
  "Cari Ekstre": "Account Statement",
  "Detay / Cari Ekstre için tıklayın": "Click for details / account statement",
  "Ad": "Name",
  "Ad / Ünvan": "Name / Title",
  "Adres": "Address",
  "Şehir": "City",
  "Ülke": "Country",
  "Toplam Bakiye": "Total Balance",
  "Açılış Bakiye": "Opening Balance",
  "Borç": "Debit",
  "Alacak": "Credit",
  "Hareket Ekle": "Add Movement",
  "Hareket bulunamadı": "No movements found",
  "Başlangıç": "Start",
  "Bitiş": "End",
  "Açıklama": "Description",
  "Açıklama / Not": "Description / Note",
  "Referans": "Reference",
  "Tür": "Type",
  "Vade Tarihi": "Due Date",
  "Çek No": "Cheque No",
  "Ödeme Yöntemi": "Payment Method",
  "Banka": "Bank",
  "Bağlı Sipariş (opsiyonel)": "Linked Order (optional)",
  "Açık Sipariş": "Open Order",
  "Ödenmiş Sipariş": "Paid Order",
  "Fatura B.": "Invoice",
  "Yazdır / PDF": "Print / PDF",
  "Veri yok": "No data",
  "-- yok --": "-- none --",
  "Güncel Kurlar:": "Current Rates:",
  "USD / TL (+%2 uygulanır)": "USD / TL (+2% applied)",
  "Fiyat Modu": "Price Mode",
  "Birim m² Fiyat (m² modunda kullanılır)": "Unit m² price (used in m² mode)",
  "m² (birim fiyat × m²)": "m² (unit price × m²)",
  "Matrix (tablo)": "Matrix (table)",
  "Ürün Adı": "Product Name",
  "Ürün Grupları & Ölçü Kuralları": "Product Groups & Size Rules",
  "Kategoriler, varyantlar, satış ve alış fiyat listeleri": "Categories, variants, sales and purchase price lists",
  "Kartelalar, yedek parça/malzeme ve ağırlık tanımları": "Colour charts, spare parts/materials and weight definitions",
  "Stok Miktarı": "Stock Quantity",
  "Min Limit": "Min Limit",
  "Depo": "Warehouse",
  "Depo & Stok": "Warehouse & Stock",
  "Tedarikçi": "Supplier",
  "Birim": "Unit",
  "Birim Fiyat": "Unit Price",
  "Miktar": "Quantity",
  "Kod": "Code",
  "Katalog": "Catalogue",
  "Görsel": "Image",
  "Kategori": "Category",
  "Kategori Ekle": "Add Category",
  "Kategori adı": "Category name",
  "Bir kategori seçin veya yeni kategori ekleyin.": "Select a category or add a new one.",
  "Bu kategoride henüz parça yok.": "No parts in this category yet.",
  "Yedek Parça / Malzeme": "Spare Parts / Materials",
  "Yeni Parça": "New Part",
  "Yeni Malzeme": "New Material",
  "Yeni Ürün": "New Product",
  "Yeni Grup": "New Group",
  "Ana Grup / Etiket": "Main Group / Label",
  "Alt Grup": "Sub Group",
  "Slug (kod)": "Slug (code)",
  "Min m²": "Min m²",
  "Min En": "Min Width",
  "Max En": "Max Width",
  "Min Boy": "Min Height",
  "Max Boy": "Max Height",
  "Min En (cm)": "Min Width (cm)",
  "Max En (cm)": "Max Width (cm)",
  "Min Boy (cm)": "Min Height (cm)",
  "Max Boy (cm)": "Max Height (cm)",
  "Yuvarlama (cm adımı)": "Rounding (cm step)",
  "KDV %": "VAT %",
  "En Çok Satılan Ürünler": "Best-selling Products",
  "Toplam Ciro (TL karşılığı)": "Total Turnover (TL equivalent)",
  "Diğer": "Other",
  "— sipariş onaylandığında düşer": "— deducted when the order is approved",
  "örn. Dikey Zip": "e.g. Vertical Zip",
  "opsiyonel (örn: A-Class Otel Grubu)": "optional (e.g. A-Class Hotel Group)",
  "mtül": "lm",
  "Metre": "Metre",
  "Top": "Roll",
  "Min": "Min",

  "En": "Width",
  "Boy": "Height",
  "Yuvarlama": "Rounding",
  "(motor & kumanda ayrı satır olarak eklenir, KDV %20)": "(motor & remote are added as separate lines, VAT 20%)",
  "İş / Proje Adı": "Job / Project Name",
  "Zincir Yönü": "Chain Direction",
  "Motor Yönü": "Motor Direction",
  "(motor & kumanda ayrı satır olarak eklenir, KDV %20)": "(motor & remote are added as separate lines, VAT 20%)",
  "Yeni Sipariş": "New Order",
  "Sipariş Düzenle": "Edit Order",
  "Cari (Müşteri)": "Account (Customer)",
  "Cari Adı": "Account Name",
  "Cari Kodu": "Account Code",
  "Vergi No": "Tax No",
  "Bakiye": "Balance",
  "Müşteri adı, kodu veya vergi no ile arayın...": "Search by customer name, code or tax no...",
  "Müşteri seç veya yeni müşteri adı yaz…": "Select a customer or type a new customer name…",
  "Eşleşen müşteri yok": "No matching customer",
  "Eşleşen müşteri yok.": "No matching customer.",
  "Eşleşen ürün grubu yok": "No matching product group",
  "Seçilen Cari:": "Selected Account:",
  "← Müşteri Değiştir": "← Change Customer",
  "← Geri": "← Back",
  "← Ürün seç": "← Select product",
  "Ürün Ekle": "Add Product",
  "Ürün Grubu Seç": "Select Product Group",
  "Ürün grubu ara…": "Search product group…",
  "Ürün adı, slug veya para birimi ile arayın...": "Search by product name, slug or currency...",
  "Yedek Parça / Malzeme Ekle": "Add Spare Part / Material",
  "Bu kategoride henüz tanımlı parça yok.": "No parts defined in this category yet.",
  "Henüz kalem eklenmedi.": "No items added yet.",
  "Henüz ürün eklenmedi. Yukarıdan \"Ürün Ekle\" ile başlayın.": "No products added yet. Start with \"Add Product\" above.",
  "Aşağıdaki formu doldurup \"Sepete Ekle\" tuşuna basın.": "Fill in the form below and press \"Add to Cart\".",
  "Proje / İş Adı": "Project / Job Name",
  "İş / Proje Adı": "Job / Project Name",
  "(müşterinin projesi veya iş adı)": "(the customer's project or job name)",
  "Son Müşteri": "End Customer",
  "(bayi'nin müşterisi · koli etiketinde yazacak)": "(the dealer's customer · printed on the box label)",
  "Termin Tarihi": "Due Date",
  "Ödeme Türü": "Payment Type",
  "Nakit/Havale": "Cash/Transfer",
  "K.Kartı (+%10)": "Credit Card (+10%)",
  "K.Kartı Farkı (+10%)": "Credit Card Surcharge (+10%)",
  "İndirim (%)": "Discount (%)",
  "İskonto %": "Discount %",
  "Montaj Bedeli Ekle": "Add Installation Fee",
  "Açıklama / Teklif Notları": "Description / Quote Notes",
  "Notlar": "Notes",
  "Ara toplam": "Subtotal",
  "Toplam": "Total",
  "Ölçü": "Size",
  "Ürün": "Product",
  "Liste F.": "List Price",
  "Final Fiyat": "Final Price",
  "Ekle": "Add",
  "Sil": "Delete",
  "Kaydet & Onayla": "Save & Confirm",
  "Kaydet & Onayla:": "Save & Confirm:",
  "Teklif Kaydet": "Save Quote",
  "Teklif Kaydet:": "Save Quote:",
  "cari bakiye değişmez ·": "account balance stays unchanged ·",
  "cari bakiyeye tutar eklenir": "the amount is added to the account balance",
  "DÜZENLENİYOR": "EDITING",
  "Opsiyonel": "Optional",
  "Adres (opsiyonel)": "Address (optional)",
  "Telefon (opsiyonel)": "Phone (optional)",
  "Örn: Ahmet Bey / Ayşe Hanım / Nurol Rezidans B7": "e.g. Mr. Smith / Nurol Residence B7",
  "Örn: Hilton Suit Odaları · Villa Yalıkavak": "e.g. Hilton Suite Rooms · Villa Yalikavak",
  "Kapat": "Close",
  "Önizleme": "Preview",
  "Önizleme hazırlanıyor…": "Preparing preview…",
  "Yazdır / Gönder": "Print / Send",
  "Belge": "Document",
  "En": "Width",
  "Boy": "Height",
  "Yuvarlama": "Rounding",
  "(motor & kumanda ayrı satır olarak eklenir, KDV %20)": "(motor & remote are added as separate lines, VAT 20%)",
  "İş / Proje Adı": "Job / Project Name",
  "Zincir Yönü": "Chain Direction",
  "Motor Yönü": "Motor Direction",
  "(motor & kumanda ayrı satır olarak eklenir, KDV %20)": "(motor & remote are added as separate lines, VAT 20%)",
  "Yeni Sipariş": "New Order",
  "Sipariş Düzenle": "Edit Order",
  "Cari (Müşteri)": "Account (Customer)",
  "Cari Adı": "Account Name",
  "Cari Kodu": "Account Code",
  "Vergi No": "Tax No",
  "Bakiye": "Balance",
  "Müşteri adı, kodu veya vergi no ile arayın...": "Search by customer name, code or tax no...",
  "Müşteri seç veya yeni müşteri adı yaz…": "Select a customer or type a new customer name…",
  "Eşleşen müşteri yok": "No matching customer",
  "Eşleşen müşteri yok.": "No matching customer.",
  "Eşleşen ürün grubu yok": "No matching product group",
  "Seçilen Cari:": "Selected Account:",
  "← Müşteri Değiştir": "← Change Customer",
  "← Geri": "← Back",
  "← Ürün seç": "← Select product",
  "Ürün Ekle": "Add Product",
  "Ürün Grubu Seç": "Select Product Group",
  "Ürün grubu ara…": "Search product group…",
  "Ürün adı, slug veya para birimi ile arayın...": "Search by product name, slug or currency...",
  "Yedek Parça / Malzeme Ekle": "Add Spare Part / Material",
  "Bu kategoride henüz tanımlı parça yok.": "No parts defined in this category yet.",
  "Henüz kalem eklenmedi.": "No items added yet.",
  "Henüz ürün eklenmedi. Yukarıdan \"Ürün Ekle\" ile başlayın.": "No products added yet. Start with \"Add Product\" above.",
  "Aşağıdaki formu doldurup \"Sepete Ekle\" tuşuna basın.": "Fill in the form below and press \"Add to Cart\".",
  "Proje / İş Adı": "Project / Job Name",
  "İş / Proje Adı": "Job / Project Name",
  "(müşterinin projesi veya iş adı)": "(the customer's project or job name)",
  "Son Müşteri": "End Customer",
  "(bayi'nin müşterisi · koli etiketinde yazacak)": "(the dealer's customer · printed on the box label)",
  "Termin Tarihi": "Due Date",
  "Ödeme Türü": "Payment Type",
  "Nakit/Havale": "Cash/Transfer",
  "K.Kartı (+%10)": "Credit Card (+10%)",
  "K.Kartı Farkı (+10%)": "Credit Card Surcharge (+10%)",
  "İndirim (%)": "Discount (%)",
  "İskonto %": "Discount %",
  "Montaj Bedeli Ekle": "Add Installation Fee",
  "Açıklama / Teklif Notları": "Description / Quote Notes",
  "Notlar": "Notes",
  "Ara toplam": "Subtotal",
  "Toplam": "Total",
  "Ölçü": "Size",
  "Ürün": "Product",
  "Liste F.": "List Price",
  "Final Fiyat": "Final Price",
  "Ekle": "Add",
  "Sil": "Delete",
  "Kaydet & Onayla": "Save & Confirm",
  "Kaydet & Onayla:": "Save & Confirm:",
  "Teklif Kaydet": "Save Quote",
  "Teklif Kaydet:": "Save Quote:",
  "cari bakiye değişmez ·": "account balance stays unchanged ·",
  "cari bakiyeye tutar eklenir": "the amount is added to the account balance",
  "DÜZENLENİYOR": "EDITING",
  "Opsiyonel": "Optional",
  "Adres (opsiyonel)": "Address (optional)",
  "Telefon (opsiyonel)": "Phone (optional)",
  "Örn: Ahmet Bey / Ayşe Hanım / Nurol Rezidans B7": "e.g. Mr. Smith / Nurol Residence B7",
  "Örn: Hilton Suit Odaları · Villa Yalıkavak": "e.g. Hilton Suite Rooms · Villa Yalikavak",
  "Görüntüle": "View",

  // — Ayarlar —
  "Genel": "General",
  "Kartela": "Colour Chart",
  "Görünüm": "Appearance",
  "Vergi Ayarları": "Tax Settings",
  "Bildirim Ayarları": "Notification Settings",
  "Hareketli Efektler": "Motion Effects",
  "Ana sayfa karşılama panelindeki akışkan arka plan hareketini ve fare ışıltısını aç/kapat.": "Toggle the fluid background motion and cursor glow on the home welcome panel.",
  "Fare İmleci": "Mouse Cursor",
  "Uygulama içinde kullanılacak fare imleci stilini seçin.": "Choose the mouse cursor style used across the app.",
  "Ana Sayfa Saati": "Home Clock",
  "Ana sayfadaki saatin görünümünü seçin — dijital (Apple yazı tipi) veya Apple analog kadran. Her iki temada da aynı görünüm kullanılır.": "Choose how the home clock looks — digital (Apple typeface) or the Apple analog dial. The same look is used in both themes.",
  "Dijital": "Digital",
  "Analog (Apple)": "Analog (Apple)",
  "Sistem Temaları": "System Themes",
  "Mevcut ZEN ERP görünümü — değişmez.": "The current ZEN ERP look — unchanged.",
  "Buzlu cam paneller, sıvı metal butonlar, yumuşak beyaz parlamalar, SF Pro tipografi.": "Frosted glass panels, liquid metal buttons, soft white glows, SF Pro typography.",
  "Saf siyah zemin, buzlu koyu cam paneller, sıvı metal butonlar, SF Pro tipografi.": "Pure black background, frosted dark glass panels, liquid metal buttons, SF Pro typography.",
  "Apple (Liquid Glass) — Açık": "Apple (Liquid Glass) — Light",
  "Apple (Liquid Glass) — Koyu": "Apple (Liquid Glass) — Dark",
  "Orijinal": "Original",
  "Özel Temalarım": "My Custom Themes",
  "Yeni Özel Tema": "New Custom Theme",
  "Henüz özel tema oluşturmadınız. Kendi renk, yazı tipi ve buton stilinizle bir tema tasarlayın.": "You haven't created a custom theme yet. Design one with your own colours, typeface and button style.",
  "Sistem Varsayılanı": "System Default",
  "Zümrüt Işıltı": "Emerald Glow",
  "Gümüş Kristal": "Silver Crystal",
};

const ORIGINAL_STATUS_TR = Object.fromEntries(
  Object.entries(STATUS_LABELS).map(([k, v]) => [k, v.tr])
);

/** Aktif dile göre metin döndürür; çeviri yoksa Türkçe metnin kendisi döner. */
export function makeTr(lang) {
  return (s) => (lang === "en" ? (EN[s] || s) : s);
}

/**
 * Sipariş durumu etiketleri uygulamanın 12 farklı yerinde `STATUS_LABELS[x].tr`
 * olarak okunuyor. Tek tek sarmalamak yerine aktif dile göre bu alanı günceller.
 */
export function applyStatusLang(lang) {
  for (const [k, v] of Object.entries(STATUS_LABELS)) {
    v.tr = lang === "en" ? (v.en || ORIGINAL_STATUS_TR[k]) : ORIGINAL_STATUS_TR[k];
  }
}

// ---- Ürün adları: İngilizce ad + (küçük puntoyla Türkçesi) ----
export const PRODUCT_EN = {
  "Stor Perde": "Roller Blind",
  "Zebra Perde": "Zebra Blind",
  "Dikey Perde": "Vertical Blind",
  "Silhouette": "Silhouette",
  "Plise 14mm (Cam Balkon)": "Pleated 14mm (Glass Balcony)",
  "Plise 20mm": "Pleated 20mm",
  "Tavan Plise": "Ceiling Pleated",
  "Dikey Zip Perde": "Vertical Zip Blind",
  "Sky Zip": "Sky Zip",
  "Dikey/Yatay Plise Sineklik": "Vertical/Horizontal Pleated Insect Screen",
  "Ahşap Jaluzi 25mm": "Wooden Venetian Blind 25mm",
  "Ahşap Jaluzi 50mm": "Wooden Venetian Blind 50mm",
  "Metal Jaluzi 16-25mm": "Metal Venetian Blind 16-25mm",
  "Çiftli Sistem": "Double System",
  "Dikey Perde Rayı": "Vertical Blind Track",
  "Kumaşsız Stor Sistemi": "Roller System (No Fabric)",
  "Sadece Kumaş": "Fabric Only",
  "Duble Yatay Plise Sineklik": "Double Horizontal Pleated Insect Screen",
  "17x25 Menteşeli ve Geçmeli Sürme Sineklik": "17x25 Hinged & Slide-in Sliding Insect Screen",
  "Ahşap Jaluzi": "Wooden Venetian Blind",
  "Metal Jaluzi": "Metal Venetian Blind",
};

/** İngilizce modda ürün adının İngilizcesini döndürür (Türkçesi ayrı gösterilir). */
export function productEn(name) {
  return PRODUCT_EN[name] || name;
}
